import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { MoveWizardStoreEffects } from './effects';
import * as fromMoveWizardStore from './reducer';

export function provideAllocationMoveWizardStoreV26(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(fromMoveWizardStore.moveWizardStoreFeatureKey, fromMoveWizardStore.reducer),
    provideEffects(MoveWizardStoreEffects),
  ]);
}
